<script setup>
const asset = (path) => `${import.meta.env.BASE_URL}${path}`
</script>

<template>
  <header class="app-header">
    <div class="app-header__inner">
      <button class="app-header__menu-button" type="button" aria-label="Open categories">
        <img :src="asset('side-bar/category-menu.svg')" alt="" aria-hidden="true" />
      </button>

      <a class="app-header__logo" href="/" aria-label="GallerySlots Casino">
        <img :src="asset('logo.svg')" alt="GallerySlots Casino" />
      </a>

      <div class="app-header__controls">
        <button class="app-header__icon-button" type="button" aria-label="Search">
          <img :src="asset('header/search.svg')" alt="Search" />
        </button>

        <div class="app-header__cashier-group">
          <div class="app-header__balance">$248.86</div>
          <button class="app-header__cashier-button" type="button" aria-label="Cashier">
            <img :src="asset('header/icon-cashier.svg')" alt="Cashier" />
            <span>Cashier</span>
          </button>
        </div>

        <button class="app-header__icon-button app-header__icon-button--badge" type="button" aria-label="Bonuses">
          <img :src="asset('header/icon-bonus.svg')" alt="Bonuses" />
          <span class="app-header__badge">8</span>
        </button>

        <button class="app-header__icon-button" type="button" aria-label="Profile">
          <img :src="asset('header/icon-profile.svg')" alt="Profile" />
        </button>
      </div>
    </div>
  </header>
</template>

<style scoped>
.app-header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 20;
  width: 100%;
  height: var(--app-header-height);
  background: var(--color-header-bg);
  border-bottom: 1px solid rgb(255 255 255 / 0.32);
}

.app-header__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  height: 100%;
  padding: 0 10px;
}

.app-header__menu-button {
  display: none;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  padding: 0;
  border: 1px solid transparent;
  border-radius: 8px;
  background:
    var(--gradient-background) padding-box,
    var(--gradient-border) border-box;
  transition: background 0.2s ease, box-shadow 0.2s ease;
}

.app-header__menu-button img {
  width: 24px;
  height: 24px;
}

.app-header__logo {
  display: inline-flex;
  align-items: center;
  flex: 0 1 auto;
  width: clamp(92px, 28vw, 118px);
  min-width: 0;
}

.app-header__logo img {
  width: 100%;
  height: auto;
}

.app-header__controls {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  gap: 6px;
  margin-left: auto;
}

.app-header__cashier-group {
  display: inline-flex;
  align-items: stretch;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: none;
}

.app-header__balance,
.app-header__cashier-button,
.app-header__icon-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  padding: 0;
}

.app-header__balance {
  display: none;
}

.app-header__cashier-button {
  width: 40px;
  height: 40px;
  gap: 0;
  border: none;
  border-radius: 8px;
  background: var(--color-accent);
  color: #fff;
  transition: background-color 0.2s ease, box-shadow 0.2s ease;
}

.app-header__icon-button {
  width: 40px;
  height: 40px;
  padding: 0;
  border: 1px solid transparent;
  border-radius: 8px;
  background:
    var(--gradient-background) padding-box,
    var(--gradient-border) border-box;
  transition: background 0.2s ease, box-shadow 0.2s ease;
}

.app-header__icon-button img,
.app-header__cashier-button img {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

.app-header__icon-button[aria-label="Search"] {
  display: none;
}

.app-header__icon-button--badge {
  position: relative;
}

.app-header__badge {
  position: absolute;
  top: -7px;
  right: -7px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 999px;
  background: var(--color-accent);
  box-shadow: 0 0 0 0 rgb(255 140 0 / 0.52);
  color: #fff;
  font-size: 0.68rem;
  font-weight: 700;
  line-height: 1;
  transform-origin: center;
  animation: app-header-badge-pulse 1.45s ease-in-out infinite;
}

@keyframes app-header-badge-pulse {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
    box-shadow: 0 0 0 0 rgb(255 140 0 / 0.48);
  }

  50% {
    opacity: 0.76;
    transform: scale(1.14);
    box-shadow: 0 0 0 7px rgb(255 140 0 / 0);
  }
}

.app-header__cashier-button {
  background: var(--color-accent);
  border-color: transparent;
  color: #fff;
}

.app-header__cashier-button span {
  display: none;
}

.app-header__icon-button:hover,
.app-header__menu-button:hover {
  background:
    var(--gradient-background-hover) padding-box,
    var(--gradient-border-hover) border-box;
  box-shadow: var(--shadow-control-hover);
}

.app-header__cashier-button:hover {
  background: var(--color-accent-hover);
  box-shadow: var(--shadow-accent-hover);
}

@media (min-width: 390px) {
  .app-header__icon-button[aria-label="Search"] {
    display: inline-flex;
  }
}

@media (min-width: 768px) {
  .app-header__inner {
    gap: 16px;
    padding: 0 30px;
  }

  .app-header__menu-button {
    display: inline-flex;
    width: 52px;
    height: 52px;
  }

  .app-header__menu-button img {
    width: 28px;
    height: 28px;
  }

  .app-header__logo {
    width: 154px;
  }

  .app-header__controls {
    gap: 12px;
  }

  .app-header__cashier-group {
    box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.08);
  }

  .app-header__balance,
  .app-header__cashier-button,
  .app-header__icon-button {
    min-height: 48px;
  }

  .app-header__balance {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 136px;
    height: 48px;
    padding: 0 16px;
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 0;
    border-right: 1px solid rgba(255, 255, 255, 0.12);
    background: rgba(255, 255, 255, 0.04);
    color: #fff;
    font-size: 1rem;
    font-weight: 600;
  }

  .app-header__cashier-button {
    width: auto;
    height: 48px;
    gap: 10px;
    padding: 0 18px;
    border-radius: 0;
  }

  .app-header__cashier-button span {
    display: inline;
    font-size: 1rem;
    font-weight: 700;
    text-transform: uppercase;
  }

  .app-header__icon-button {
    width: 48px;
    height: 48px;
  }

  .app-header__icon-button[aria-label="Search"] {
    display: inline-flex;
  }

  .app-header__icon-button img,
  .app-header__cashier-button img {
    width: 22px;
    height: 22px;
  }

  .app-header__badge {
    width: 20px;
    height: 20px;
    font-size: 0.75rem;
  }
}
</style>
